import {React} from "react";
import {Container} from 'react-bootstrap';

const DatosDestino = ({destino}) => {
    return(
        <div className="pt-2 pb-5">
            <h1 className="text-center mb-5">{destino.elnombre}</h1>
            <Container>
                <div className="noticia-individual-descripcio-llarga">
                    <div dangerouslySetInnerHTML={{__html: destino.eltexto}}></div>
                </div>
            </Container>
        </div>
    );
}

export default DatosDestino;
